import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { ArbeitsartKonfiguration, ZeitEintragZuordnungTyp } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { UntypedFormBuilder } from '@angular/forms';
import { UiHelper } from 'src/app/api/helper/ui-helper';


import { ZeitEintragEx } from 'src/app/api/model/model';
import { Zeiterfassung } from 'src/app/api/helper/zeiterfassung-helper';

@Component({
    selector: 'app-stoerzeit-edit',
    templateUrl: './stoerzeit-edit.page.html',
    styleUrls: ['./stoerzeit-edit.page.scss'],
    standalone: false
})
export class StoerzeitEditPage implements OnInit, AfterViewInit, OnDestroy {
    log = new Logger("StoerzeitEditPage");

    @Input() eintrag: ZeitEintragEx;
    @Input() isAendern: boolean;

    // Kopie auf der gearbeitet wird
    entity: ZeitEintragEx;

    aktivSeit = '';

    subscriptions: Subscription[] = [];
    arbeitszeitArtenListe: ArbeitsartKonfiguration[];

    constructor(
        public formBuilder: UntypedFormBuilder,
        private auftragService: AuftragService,
        private popoverController: PopoverController,
        private remoteService: RemoteService,
        private cdr: ChangeDetectorRef) {
    }

    async ionViewWillEnter() {
        this.log?.debug('ionViewWillEnter');
    }

    ionViewDidEnter() {
        MyApp.current.backAction = () => this.onAbbrechen();
    }

    async ionViewWillLeave() {
        this.log?.debug('ionViewWillLeave');
        MyApp.current.backAction = null;
        MyApp.loading(false);
    }

    async ngOnInit() {
        this.entity = { ... this.eintrag };

        if (this.entity.Zuordnung === ZeitEintragZuordnungTyp.Auftrag) {
            this.arbeitszeitArtenListe = Zeiterfassung.getArbeitszeitArten('Auftrag');
        } else {
            this.arbeitszeitArtenListe = Zeiterfassung.getArbeitszeitArten('Tour');
        }
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    onArtChanged(e: any) {
        this.log?.debug('onArtChanged', e);

        const def = this.arbeitszeitArtenListe.find(p => p.Name === this.entity.ArtName);

        if (def) {
            this.entity.ArtKey = def.Key;
            this.entity.ArtName = def.Name;
            this.entity.ArtReferenz = def.Referenz;
        }

        // if (definition && definition.StandardDauer) {
        //     this.form.get('dauer').setValue(definition.StandardDauer);
        // }
    }

    onLoeschen() {
        this.popoverController.dismiss('loeschen');
    }

    onSpeichern() {
        // App.loading(true);

        try {
            // Übernehme die Daten
            this.eintrag.ArtKey = this.entity.ArtKey;
            this.eintrag.ArtName = this.entity.ArtName;
            this.eintrag.ArtReferenz = this.entity.ArtReferenz;
            this.eintrag.Bemerkung = this.entity.Bemerkung;

            this.popoverController.dismiss('gespeichert');
        } catch (err) {
            UiHelper.showError(err);
        }
    }

    onAbbrechen() {
        this.dismiss();
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.popoverController.dismiss(false);
    }
}
